import { useEffect, useRef } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import {
  Tabs,
  apiAbortController,
  PermissionDenied,
  PermissionEnum,
} from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import {
  clearListOfWarningsState,
  clearState,
  clearOrganizationsWarningsState,
} from './store/slice';
import { useLazyGetWarningReportsDictionariesQuery } from './store/service';

import cn from './warning-report.module.css';

import ROUTES from '../../routes';

const WarningReport = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const match = useMatch(ROUTES.WARNING_REPORT);
  const navigate = useNavigate();

  const { activePermissions } = useAppSelector(
    (state) => state.reportsDictionaries,
  );

  const [getDictionaries] = useLazyGetWarningReportsDictionariesQuery();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (match && activePermissions?.includes(PermissionEnum.WARNINGS_LIST)) {
      navigate(ROUTES.WARNING_REPORT_OVERVIEW);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    if (activePermissions?.includes(PermissionEnum.WARNINGS_LIST)) {
      getDictionaries();
    }

    return () => {
      dispatch(clearState());
      dispatch(clearListOfWarningsState());
      dispatch(clearOrganizationsWarningsState());
    };
  }, [activePermissions]);

  let content;

  if (!activePermissions?.includes(PermissionEnum.WARNINGS_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <div className={cn.warningReport}>
        <div className={cn.warningReportTop}>
          <div className={cn.warningReportTitle}>Warnings report</div>
          <Tabs
            wrapperClassName={cn.warningReportTabs}
            tabs={[
              {
                name: 'Overview',
                path: ROUTES.WARNING_REPORT_OVERVIEW,
              },
              {
                name: 'Customers',
                path: ROUTES.WARNING_REPORT_CUSTOMERS,
              },
              {
                name: 'List',
                path: ROUTES.WARNING_REPORT_LIST,
              },
            ]}
            onRouterClick={() => apiAbortController.abortPendingRequest()}
            enableRouting
          />
        </div>
        <div className={cn.warningReportContent} ref={ref}>
          <Outlet context={{ ref }} />
        </div>
      </div>
    );
  }

  return content;
};

export default WarningReport;
